import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from './Config';
import './Profile.css';
import '../components/SportMentalTest/SportMentalTestsScreen.css';
import logoImage from '../resources/1000028180.jpeg';
import LoadingSpinner from './LoadingSpinner';

export default function Profile() {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showPasswordForm, setShowPasswordForm] = useState(false);
  const [passwordData, setPasswordData] = useState({
    current_password: '',
    new_password: '',
    confirm_password: ''
  });
  const [passwordError, setPasswordError] = useState('');
  const [passwordSuccess, setPasswordSuccess] = useState('');

  useEffect(() => {
    fetchUserProfile();
  }, []);

  const fetchUserProfile = async () => {
    try {
      const token = localStorage.getItem('accessToken') || localStorage.getItem('token');
      if (!token) {
        setError('No authentication token found');
        setLoading(false);
        return;
      }
      const response = await fetch(`${BASE_URL}/api/user/profile`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      if (!response.ok) {
        throw new Error('Failed to fetch profile data');
      }
      const data = await response.json();
      setUserInfo(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordChange = (e) => {
    setPasswordData({
      ...passwordData,
      [e.target.name]: e.target.value
    });
    setPasswordError('');
    setPasswordSuccess('');
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    if (!passwordData.current_password || !passwordData.new_password || !passwordData.confirm_password) {
      setPasswordError('All fields are required');
      return;
    }
    if (passwordData.new_password !== passwordData.confirm_password) {
      setPasswordError('New passwords do not match');
      return;
    }
    if (passwordData.new_password.length < 6) {
      setPasswordError('New password must be at least 6 characters long');
      return;
    }
    try {
      const token = localStorage.getItem('accessToken') || localStorage.getItem('token');
      const response = await fetch(`${BASE_URL}/api/user/update_password`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          current_password: passwordData.current_password,
          new_password: passwordData.new_password
        })
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to update password');
      }
      setPasswordSuccess('Password updated successfully!');
      setPasswordData({
        current_password: '',
        new_password: '',
        confirm_password: ''
      });
      setTimeout(() => {
        setShowPasswordForm(false);
        setPasswordSuccess('');
      }, 2000);
    } catch (err) {
      setPasswordError(err.message);
    }
  };

  if (loading) {
    return (
      <div className="dashboard-container" style={{minHeight: '100vh', background: 'linear-gradient(to top left, #2AA7A1 -25.98%, #E0F7F4 66.42%)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Poppins, sans-serif'}}>
        <LoadingSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="dashboard-container" style={{minHeight: '100vh', background: 'linear-gradient(to top left, #2AA7A1 -25.98%, #E0F7F4 66.42%)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Poppins, sans-serif'}}>
        <div className="dashboard-card" style={{
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center', 
          minHeight: 300, 
          fontFamily: 'Poppins, sans-serif',
          maxWidth: 500,
          padding: '48px',
          borderRadius: '24px',
          boxShadow: '0 20px 40px rgba(0,0,0,0.10)',
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)'
        }}>
          <div style={{
            color: '#dc2626', 
            fontWeight: 600, 
            fontSize: 18, 
            marginBottom: 16, 
            fontFamily: 'Poppins, sans-serif',
            textAlign: 'center'
          }}>
            Error: {error}
          </div>
          <button 
            className="update-password-btn" 
            onClick={() => navigate('/dashboard')}
            style={{
              background: '#2aa7a1',
              color: '#ffffff',
              border: 'none',
              borderRadius: '12px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              height: '48px',
              padding: '0 24px',
              fontFamily: 'Poppins, sans-serif'
            }}
          >
            Back to Dashboard
          </button>
              </div>
      
      {/* Footer */}
      <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
        padding: '12px 0',
        textAlign: 'center',
        fontFamily: 'Poppins, sans-serif',
        zIndex: 100
      }}>
        <p style={{
          margin: 0,
          fontSize: '14px',
          color: 'rgba(75, 75, 75, 0.8)',
          fontWeight: 400
        }}>
          © 2025 All rights reserved Power Mind Metrics
        </p>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-container" style={{minHeight: '100vh', background: 'linear-gradient(to top left, #2AA7A1 -25.98%, #E0F7F4 66.42%)', fontFamily: 'Poppins, sans-serif'}}>
      {/* Header */}
      <header className="dashboard-header" style={{position: 'static'}}>
        <div className="header-content">
          <div className="header-logo-container">
                                  <img
                        src={logoImage}
                        alt="Power Mind Metrics Logo"
                        style={{ height: "90px", width: "100px", marginRight: "10px" }}
                      />
            <h1 className="header-logo">Power Mind Metrics</h1>
          </div>
          <nav className="header-nav">
            <button className="nav-link" onClick={() => navigate('/dashboard')}>Dashboard</button>
            <button className="nav-link" onClick={() => navigate('/logout')}>Logout</button>
          </nav>
        </div>
      </header>

      {/* Main Content */}
      <main className="dashboard-main" style={{marginTop: '50px'}}>
        <div className="dashboard-card" style={{
          maxWidth: 800, 
          width: '100%',
          margin: '0 auto', 
          padding: '48px', 
          borderRadius: '24px', 
          boxShadow: '0 20px 40px rgba(0,0,0,0.10)', 
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          fontFamily: 'Poppins, sans-serif'
        }}>
          <h2 className="main-title" style={{
            marginBottom: '40px', 
            fontSize: '32px', 
            fontWeight: '600', 
            color: 'rgba(75,75,75,1)', 
            fontFamily: 'Poppins, sans-serif', 
            textAlign: 'center'
          }}>User Profile</h2>
          
          {/* Profile Information */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            marginBottom: '40px',
            fontFamily: 'Poppins, sans-serif',
            fontSize: '16px',
            color: 'rgba(75,75,75,1)',
            width: '100%'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '16px 20px',
              backgroundColor: '#f8fafc',
              borderRadius: '12px',
              border: '1px solid #e2e8f0'
            }}>
              <span style={{fontWeight: '600', color: '#374151'}}>Full Name:</span>      
              <span style={{fontWeight: '500', color: '#1f2937'}}>{userInfo.full_name || 'N/A'}</span>
            </div>
            
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '16px 20px',
              backgroundColor: '#f8fafc',
              borderRadius: '12px',
              border: '1px solid #e2e8f0'
            }}>
              <span style={{fontWeight: '600', color: '#374151'}}>Username:</span>
              <span style={{fontWeight: '500', color: '#1f2937'}}>{userInfo.user_name || 'N/A'}</span>
            </div>
            
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '16px 20px',
              backgroundColor: '#f8fafc',
              borderRadius: '12px',
              border: '1px solid #e2e8f0'
            }}>
              <span style={{fontWeight: '600', color: '#374151'}}>Gender:</span>
              <span style={{fontWeight: '500', color: '#1f2937'}}>{userInfo.gender || 'N/A'}</span>
            </div>
            
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '16px 20px',
              backgroundColor: '#f8fafc',
              borderRadius: '12px',
              border: '1px solid #e2e8f0'
            }}>
              <span style={{fontWeight: '600', color: '#374151'}}>Date of Birth:</span>
              <span style={{fontWeight: '500', color: '#1f2937'}}>{userInfo.dob || 'N/A'}</span>
            </div>
            
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '16px 20px',
              backgroundColor: '#f8fafc',
              borderRadius: '12px',
              border: '1px solid #e2e8f0'
            }}>
              <span style={{fontWeight: '600', color: '#374151'}}>Role:</span>
              <span style={{fontWeight: '500', color: '#1f2937'}}>{userInfo.role || 'N/A'}</span>
            </div>
        </div>
          
          {/* Password Update Section */}
          <div style={{display: 'flex', flexDirection: 'column', gap: '16px', alignItems: 'center', width: '100%'}}>
          <button 
            className="update-password-btn"
            onClick={() => setShowPasswordForm(!showPasswordForm)}
              style={{
                width: '100%', 
                maxWidth: '400px',
                background: '#2aa7a1',
                color: '#ffffff',
                border: 'none',
                borderRadius: '12px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                height: '48px',
                fontFamily: 'Poppins, sans-serif'
              }}
          >
            {showPasswordForm ? 'Cancel Password Update' : 'Update Password'}
          </button>
            
          {showPasswordForm && (
              <form onSubmit={handlePasswordSubmit} style={{
                marginTop: '24px', 
                width: '100%', 
                maxWidth: '500px', 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center',
                gap: '20px'
              }}>
                <h3 style={{
                  fontWeight: '600', 
                  fontSize: '20px', 
                  marginBottom: '8px', 
                  textAlign: 'center', 
                  fontFamily: 'Poppins, sans-serif',
                  color: '#374151'
                }}>Update Password</h3>
                
                {passwordError && (
                  <div style={{
                    color: '#dc2626', 
                    fontWeight: '500', 
                    marginBottom: '8px', 
                    fontFamily: 'Poppins, sans-serif',
                    backgroundColor: '#fef2f2',
                    padding: '12px 16px',
                    borderRadius: '8px',
                    border: '1px solid #fecaca',
                    width: '100%',
                    textAlign: 'center'
                  }}>
                    {passwordError}
                  </div>
                )}
                
                {passwordSuccess && (
                  <div style={{
                    color: '#16a34a', 
                    fontWeight: '500', 
                    marginBottom: '8px', 
                    fontFamily: 'Poppins, sans-serif',
                    backgroundColor: '#f0fdf4',
                    padding: '12px 16px',
                    borderRadius: '8px',
                    border: '1px solid #bbf7d0',
                    width: '100%',
                    textAlign: 'center'
                  }}>
                    {passwordSuccess}
                  </div>
                )}
                
                <div style={{width: '100%'}}>
                  <label style={{
                    width: '100%', 
                    fontSize: '16px', 
                    color: '#374151', 
                    lineHeight: '150%', 
                    display: 'block', 
                    marginBottom: '8px', 
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: '500'
                  }}>
                    Current Password
                  </label>
                <input
                  type="password"
                  name="current_password"
                  value={passwordData.current_password}
                  onChange={handlePasswordChange}
                  placeholder="Enter current password"
                  style={{
                    width: '100%',
                      height: '48px',
                    borderRadius: '8px',
                      padding: '0 16px',
                      border: '1px solid #d1d5db',
                    fontSize: '16px',
                      fontFamily: 'Poppins, sans-serif',
                    outline: 'none',
                    transition: 'border-color 0.2s',
                      boxSizing: 'border-box'
                  }}
                />
              </div>
                
                <div style={{width: '100%'}}>
                  <label style={{
                    width: '100%', 
                    fontSize: '16px', 
                    color: '#374151', 
                    lineHeight: '150%', 
                    display: 'block', 
                    marginBottom: '8px', 
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: '500'
                  }}>
                    New Password
                  </label>
                <input
                  type="password"
                  name="new_password"
                  value={passwordData.new_password}
                  onChange={handlePasswordChange}
                  placeholder="Enter new password"
                  style={{
                    width: '100%',
                      height: '48px',
                    borderRadius: '8px',
                      padding: '0 16px',
                      border: '1px solid #d1d5db',
                    fontSize: '16px',
                      fontFamily: 'Poppins, sans-serif',
                    outline: 'none',
                    transition: 'border-color 0.2s',
                      boxSizing: 'border-box'
                  }}
                />
              </div>
                
                <div style={{width: '100%'}}>
                  <label style={{
                    width: '100%', 
                    fontSize: '16px', 
                    color: '#374151', 
                    lineHeight: '150%', 
                    display: 'block', 
                    marginBottom: '8px', 
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: '500'
                  }}>
                    Confirm New Password
                  </label>
                <input
                  type="password"
                  name="confirm_password"
                  value={passwordData.confirm_password}
                  onChange={handlePasswordChange}
                  placeholder="Confirm new password"
                  style={{
                    width: '100%',
                      height: '48px',
                    borderRadius: '8px',
                      padding: '0 16px',
                      border: '1px solid #d1d5db',
                    fontSize: '16px',
                      fontFamily: 'Poppins, sans-serif',
                    outline: 'none',
                    transition: 'border-color 0.2s',
                      boxSizing: 'border-box'
                    }}
                  />
                </div>
                
                <button 
                  type="submit"  
                  style={{
                    width: '100%', 
                    background: '#2aa7a1', 
                    color: '#ffffff', 
                    border: 'none', 
                    borderRadius: '12px', 
                    fontSize: '16px', 
                    fontWeight: '600', 
                    cursor: 'pointer', 
                    transition: 'all 0.2s ease', 
                    height: '48px', 
                    fontFamily: 'Poppins, sans-serif',
                    marginTop: '8px'
                  }}
                >
                Update Password
              </button>
            </form>
          )}
          </div>
        </div>
      </main>
      
      {/* Footer */}
      <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
        padding: '12px 0',
        textAlign: 'center',
        fontFamily: 'Poppins, sans-serif',
        zIndex: 100
      }}>
        <p style={{
          margin: 0,
          fontSize: '14px',
          color: 'rgba(75, 75, 75, 0.8)',
          fontWeight: 400
        }}>
          © 2025 All rights reserved Power Mind Metrics
        </p>
      </div>
    </div>
  );
} 